import importerReducers from 'modules/shared/importer/importerReducers';
import actions from 'modules/company/importer/companyImporterActions';

export default importerReducers(actions);
